import { useMutation } from '@apollo/client';
import { ADD_TO_WORLD_MAP_SET } from 'graphql/mutation/worldMutation';
import {
    AddToWorldMapSet,
    AddToWorldMapSetVariables
} from 'graphql/mutation/__generated__/AddToWorldMapSet';
import { WorldMapSets_worldMap_worldMapSets } from 'graphql/query/__generated__/WorldMapSets';
import { cacheAddMarkerToWorldMapSet } from 'hooks/marker/cacheUpdateMethods';
import { useWorldMapLocalStorage } from 'libs/hooks/ownership/useWorldMapLocalStorage';

export const useAddMarkerToSetMutation = () => {
    const { getTokenForMapId } = useWorldMapLocalStorage();
    const [mutation] = useMutation<AddToWorldMapSet, AddToWorldMapSetVariables>(
        ADD_TO_WORLD_MAP_SET
    );

    const sendMutation = (params: {
        mapSet: WorldMapSets_worldMap_worldMapSets;
        markerId: string;
        worldMapId: string;
    }) => {
        mutation({
            variables: {
                worldMapSetId: params.mapSet.worldMapSetId,
                worldMapMarkerId: params.markerId,
                token: getTokenForMapId(params.worldMapId)
            },
            optimisticResponse: {
                addToWorldMapSet: {
                    ...params.mapSet,
                    markers: [
                        ...params.mapSet.markers,
                        {
                            worldMapMarkerId: params.markerId,
                            __typename: 'WorldMapMarker'
                        }
                    ]
                }
            },
            update: (cache, result) => {
                cacheAddMarkerToWorldMapSet(cache, params.markerId, result.data.addToWorldMapSet);
            }
        });
    };

    return [sendMutation];
};
